import styled, { keyframes } from 'styled-components';
import { BLACK_COLOR, DARK_RED, DEFAULT_FONT, WHITE_COLOR } from '../../styles/variables';

const popIn = keyframes` 
from {
  transform: scale(0);
}
to {
  transform: scale(1);
}
`;

export const DocListOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 5%;
  height: 100vh;
  width: 95%;
  background-color: ${WHITE_COLOR};
  z-index: 2;
  animation: ${popIn} ease 300ms;
  display: flex;
  flex-direction: column;
`;

export const CloseIcon = styled.div`
  color: ${BLACK_COLOR};
  .anticon svg:hover {
    color: ${DARK_RED};
    cursor: pointer;
    transform: scale(125%);
    transition: 200ms ease transform;
  }
`;

export const ContentContainer = styled.div`
  height: ${props => props.height};
  display: flex;
`;

export const StepsContainer = styled.div`
  width: ${props => props.width};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  position: relative;
  background: ${WHITE_COLOR} !important;
  z-index: 1000;
  .ant-steps-item-content {
    width: 80% !important;
  }
  .ant-steps-item-process .ant-steps-item-title {
    font-weight: 600 !important;
  }
  .ant-steps-item-container {
    height: 100px;
  }
  .ant-steps-item-title {
    font-size: .9rem;
  }
`;

export const DocListFooter = styled.div`
  pointer-events: ${(props) => props.isLoading ? "none" : "all"};
  opacity: ${(props) => props.isLoading ? ".5" : "1"};
  display: flex;
  flex-grow: 1;
  height: ${props => props.height};
  width: ${props => props.width};
  margin-left: ${props => props.width && '20%'};
  justify-content: flex-end;
  align-items: center;
  padding: 0 24px;
  div {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .ant-btn-primary,
  .ant-btn {
    width: 160px;
    color: ${WHITE_COLOR};
    background-color: #66b5ff;
    border: 0;
    height: 38px;
    text-transform: uppercase;
    font-family: ${DEFAULT_FONT};
    font-weight: 600;
    font-size: 12px !important;
    letter-spacing: 2px;
    border-radius: 50px;
    transition: all 0.4s ease-in-out;
  }
  .ant-btn-primary:hover,
  .ant-btn:hover {
    transform: scale(104%);
  }
  .customButton {
    width: 180px;
    font-size: 14px;
    font-family: ${DEFAULT_FONT} !important;
    text-transform: uppercase;
    font-weight: 700;
    color: ${WHITE_COLOR};
    letter-spacing: 1px;
    cursor: pointer;
    height: 38px;
    color: ${WHITE_COLOR};
    cursor: pointer;
    text-align: center;
    border: none;
    background-size: 300% 100%;
    border-radius: 50px;
    moz-transition: all 0.4s ease-in-out;
    -o-transition: all 0.4s ease-in-out;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    background-image: linear-gradient(to right, #25aae1, #4481eb, #04befe, #3f86ed);
  }
  .deleteButton {
    width: 240px;
    background-image: linear-gradient(to right, #eb3941, #f15e64, #e14e53, #e2373f);
    box-shadow: 0 5px 15px rgba(242, 97, 103, 0.4);
  }
  .customButton:hover {
    background-position: 100% 0;
    moz-transition: all 0.4s ease-in-out;
    -o-transition: all 0.4s ease-in-out;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    transform: scale(104%);
  }
  .customButton:focus {
    outline: none;
  }
`;

export const CountWrapperContainer = styled.div`
  width: 20%;
  position: relative;
  z-index: 5;
  background-color: ${WHITE_COLOR};
`

export const CountWrapper = styled.div`
  text-align: center;
  font-weight: 600;
  margin-top: 24px;
  hr {
    width: 40%;
  }
  p {
    font-size: 12px;
  }
  h3 {
    font-size: 16px;
  }
`;
